import { Field, useFormikContext } from "formik";
import React, { useEffect } from "react";
import {
  resetChildLinkedList,
  getLabelAndValue,
  convertTextToTitleCase,
} from "../../CommonFuntion/SchemaValidation";
import Tooltip from "@mui/material/Tooltip";
import TableBody from "@mui/material/TableBody";
import WarningIcon from "@mui/icons-material/Warning";
import { pink } from "@mui/material/colors";
import { TableCheckbox } from "./TableCheckbox";
import TableILISelectField from "./TableILISelectField";
export function CCLTableBodyFormik(props) {
  const formikProps = useFormikContext();
  let { errors, values, setFieldValue } = formikProps;
  const { name, value, careControls, schemaPageId, schemaResult, itemId } =
    props;
  const [table, settable] = React.useState([]);

  useEffect(() => {
    let arr = [];

    arr.push(careControls);

    settable(arr);
  }, [careControls]);

  useEffect(() => {
    if (value) {
      setTimeout(function () {
        setFieldValue([name], value);
      }, 300);
    }
  }, []);

  const getFormElementtr = (parentkey, parentvalue) => {
    return (
      <tr key={parentvalue}>
        {parentkey &&
          parentkey.map((key, value) => (
            <td rowkey={parentvalue} key={value}>
              {getFormElement(key, value, parentvalue, name)}
            </td>
          ))}
      </tr>
    );
  };

  const getFormElement = (element, key, parentvalue, tableName) => {
    const id = element.prefix + element.pageId + element.tagName;
    const name = element.fieldName;
    const option = element.options;
    const rowkeys = key;
    const tdkeys = parentvalue;
    const error = errors?.[tableName]?.find((x) => x?.index === tdkeys);
    const errorBorder = error?.[name] ? "error-border" : "";
    if (element?.prefix === "LABEL") {
      return <label>{key + 1}</label>;
    }
    if (element?.prefix === "TXT") {
      const textboxChange = (e) => {
        const { value } = e.target;
        const name2 = `${tableName}[${tdkeys}].${name}`;
        if (element.validation.characterCase) {
          switch (element.validation.characterCase) {
            case "U":
              setFieldValue(name2, value.toUpperCase());
              break;
            case "L":
              setFieldValue(name2, value.toLowerCase());
              break;
            case "C":
              setFieldValue(name2, convertTextToTitleCase(value));
              break;
            default:
              setFieldValue(name2, value);
              break;
          }
        } else {
          setFieldValue(name2, value);
        }
      };

      return (
        <>
          <div className="wrapper">
            <div>
              <Field
                maxLength={
                  element.validation.pictureMask
                    ? element.validation.pictureMask.replace(/"/g, "").length
                    : ""
                }
                title={
                  (element.validation.pictureMask
                    ? "Picture Mask:" +
                      element.validation.pictureMask.replace(/"/g, "")
                    : "") + (element.validation.mandatory ? "\nMandatory" : "")
                }
                //className="invalid"
                type="text"
                className={`tableInput ${errorBorder}`}
                id={id + tdkeys + 1}
                rowkeys={tdkeys}
                tdkeys={rowkeys}
                name={`${tableName}[${tdkeys}].${name}`}
                onChange={textboxChange}
              />

              {error?.[name] && (
                <span className="icon">
                  <Tooltip title={error?.[name]}>
                    <WarningIcon sx={{ color: pink[500] }} />
                  </Tooltip>
                </span>
              )}
            </div>
          </div>
        </>
      );
    }
    if (element?.prefix === "BAR") {
      var strCharactersText;
      var strHelpText;
      if (
        element.calculation === "3" ||
        element.type === "4" ||
        element.type === "5" ||
        element.type === "8" ||
        element.type === "9"
      )
        strCharactersText = "No. Characters: " + element.size;
      else strCharactersText = "Max. Characters: " + element.size;

      switch (element.type) {
        case "0":
          strHelpText =
            "Code 39 - Full ASCII, " +
            strCharactersText +
            ", Valid characters: Alphanumeric '-', '.', ' ', '%', '$', '/', '+'";
          break;
        case "1":
          strHelpText =
            "Code 39 - Normal, " +
            strCharactersText +
            ", Valid characters: Alphanumeric '-', '.', ' ', '%', '$', '/', '+'";
          break;
        case "2":
          strHelpText =
            "Code 93, " +
            strCharactersText +
            ", Valid characters: Alphanumeric '-', '.', ' ', '%', '$', '/', '+', '(', ')'";
          break;

        case "3":
          strHelpText =
            "Code 128, " +
            strCharactersText +
            ", Valid characters: All Characters";
          break;

        case "4":
          strHelpText =
            "EAN-8, " + strCharactersText + ", Valid characters: Numeric";
          break;
        case "5":
          strHelpText =
            "EAN-13, " + strCharactersText + ", Valid characters: Numeric";
          break;
        case "6":
          strHelpText =
            "EAN/UPC 128, " +
            strCharactersText +
            ", Valid characters: All Characters";
          break;
        case "7":
          strHelpText =
            "Interleaved 2 of 5, " +
            strCharactersText +
            ", Numeric: All Characters";
          break;
        case "8":
          strHelpText =
            "UPC-A, " + strCharactersText + ", Valid characters: Numeric";
          break;
        case "9":
          strHelpText =
            "UPC-E, " + strCharactersText + ", Valid characters: Numeric";
          break;
        default:
          break;
      }
      switch (element.calculation) {
        case "0":
          strHelpText = strHelpText + ", Check digit: Validated";
          break;
        case "1":
          strHelpText = strHelpText + ", Check digit: Calculated";
          break;
        case "2":
          strHelpText = strHelpText + ", Check digit: Ignore";
          break;

        case "3":
          strHelpText = strHelpText + ", Check digit: Override";
          break;
        default:
          break;
      }
      return (
        <>
          <div className="wrapper">
            <div>
              <Field
                maxLength={element.size}
                title={
                  strHelpText +
                  (element.validation.pictureMask
                    ? "\nPicture Mask:" +
                      element.validation.pictureMask.replace(/"/g, "")
                    : "") +
                  (element.validation.mandatory ? "\nMandatory" : "")
                }
                type="text"
                className={`tableInput ${errorBorder}`}
                id={id + tdkeys + 1}
                rowkeys={tdkeys}
                tdkeys={rowkeys}
                name={`${tableName}[${tdkeys}].${name}`}
              />
              {error?.[name] && (
                <span className="icon">
                  <Tooltip title={error?.[name]}>
                    <WarningIcon sx={{ color: pink[500] }} />
                  </Tooltip>
                </span>
              )}
            </div>
          </div>
        </>
      );
    }
    if (element?.prefix === "QTY") {
      return (
        <>
          <div className="wrapper">
            <div>
              <Field
                title={
                  (element.validation.pictureMask
                    ? "Picture Mask:" +
                      element.validation.pictureMask.replace(/"/g, "")
                    : "") + (element.validation.mandatory ? "\nMandatory" : "")
                }
                type="text"
                className={`tableInput ${errorBorder}`}
                id={id + tdkeys + 1}
                rowkeys={tdkeys}
                tdkeys={rowkeys}
                name={`${tableName}[${tdkeys}].${name}`}
                onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
              />
              {error?.[name] && (
                <span className="icon">
                  <Tooltip title={error?.[name]}>
                    <WarningIcon sx={{ color: pink[500] }} />
                  </Tooltip>
                </span>
              )}
            </div>
          </div>
        </>
      );
    }
    if (element?.prefix === "SLI") {
      return (
        <>
          <div className="wrapper">
            <div className="form-field">
              <Field
                as="select"
                className={`tableInput ${errorBorder}`}
                id={id + tdkeys + 1}
                rowkeys={tdkeys}
                tdkeys={rowkeys}
                name={`${tableName}[${tdkeys}].${name}`}
              >
                <option value=""></option>
                {option.map((i, index) => (
                  <option key={index} value={i.label}>
                    {i.label}
                  </option>
                ))}
              </Field>
              {error?.[name] && (
                <span className="icon">
                  <Tooltip title={error?.[name]}>
                    <WarningIcon sx={{ color: pink[500] }} />
                  </Tooltip>
                </span>
              )}
            </div>
          </div>
        </>
      );
    }
    if (element.prefix === "ILI") {
      return (
        <TableILISelectField
          element={element}
          option={option}
          error={error}
          id={id}
          tdkeys={tdkeys}
          rowkeys={rowkeys}
          tableName={tableName}
          name={name}
          errorBorder={errorBorder}
          values={values}
        />
      );
    }

    if (element.prefix === "ELC") {
      const parentPageId = element.parentId?.split("|")?.[0];
      const parentId = element.parentId?.split("|")?.[1];
      let options = [],
        schema = {},
        dropDownValue = "";
      if (parentPageId == schemaPageId && element?.lists) {
        schema = schemaResult?.find((x) => x.schemaItem == parentId);
        dropDownValue = values[schema?.fieldName];
      } else if (parentPageId == itemId && element?.lists) {
        schema = careControls?.find((x) => x.schemaItem == parentId);
        dropDownValue = values[tableName]?.[tdkeys]?.[schema?.fieldName];
      }
      if (dropDownValue?.length > 0) {
        for (const [key, value] of Object.entries(element.lists)) {
          if (key == getLabelAndValue(dropDownValue)[1]) {
            options = value;
            break;
          }
        }
        if (options.length == 0)
          options = [
            {
              label: "N/A",
              value: "N/A",
            },
          ];
      }

      const handleChange = (e) => {
        const option = options.find((x) => x.label == e.target.value);
        setFieldValue(
          `${tableName}[${tdkeys}].${name}`,
          option?.label + "|" + option?.value
        );
        const tableObj = {
          tableName,
          fieldName: name,
          careControls: careControls,
        };
        resetChildLinkedList(
          tableObj,
          itemId,
          element.schemaItem,
          values,
          parentvalue,
          setFieldValue
        );
      };

      return (
        <>
          <div className="wrapper">
            <div>
              <Field
                as="select"
                className={`tableInput ${errorBorder}`}
                id={id + tdkeys + 1}
                rowkeys={tdkeys}
                tdkeys={rowkeys}
                name={`${tableName}[${tdkeys}].${name}`}
                onChange={handleChange}
                value={
                  getLabelAndValue(values[tableName][tdkeys][name])[0] || ""
                }
              >
                <option value=""></option>
                {options.map((i, index) => (
                  <option key={index} value={i.label}>
                    {i.label}
                  </option>
                ))}
              </Field>
              {error?.[name] && (
                <span className="icon">
                  <Tooltip title={error?.[name]}>
                    <WarningIcon sx={{ color: pink[500] }} />
                  </Tooltip>
                </span>
              )}
            </div>
          </div>
        </>
      );
    }
    if (element.prefix === "CHK") {
      let value = values[tableName][tdkeys][name];
      value = value === "" ? "N" : value;
      const test = { name: `${tableName}[${tdkeys}].${name}`, value };
      return <TableCheckbox {...test} />;
    }
  };
  return (
    <>
      <TableBody>
        {table.length !== 0 &&
          table.map((parentkey, parentvalue) =>
            getFormElementtr(parentkey, parentvalue)
          )}
      </TableBody>
    </>
  );
}

export default CCLTableBodyFormik;
